import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { cn } from "../utils/styling";
import { Button } from "./ButtonNew";
import { FormRowLabel } from "./FormRowLabel";

export const YesNoToggle = ({
  children,
  onChange,
  question,
  value,
}: {
  children?: React.ReactNode;
  onChange: (next: boolean) => void;
  question: string;
  value?: boolean;
}) => {
  const { t } = useTranslation();

  const buttonsProps = [
    {
      activeOn: true,
      key: "yes",
    },
    {
      activeOn: false,
      key: "no",
    },
  ];

  return (
    <Stack className="min-h-12 w-full flex-col gap-4 rounded-xl bg-lds-surface-muted px-4 py-2 border-ds-subtle">
      <Stack className="w-full justify-between gap-4 ">
        <p className="font-ds-body-regular-md">{question}</p>
        <Stack className="rounded-full bg-lds-surface-subtle p-[2px]">
          {buttonsProps.map((button) => (
            <Button
              className="!h-7 !rounded-[14px] !px-4"
              key={button.key}
              onClick={() => onChange(button.activeOn)}
              variant={value === button.activeOn ? "primary" : "tertiary"}
            >
              {t(`general.${button.key}`)}
            </Button>
          ))}
        </Stack>
      </Stack>
      {children}
    </Stack>
  );
};

export const YesNoToggleRow = ({
  children,
  className,
  onChange,
  question,
  title,
  value = false,
}: {
  children?: React.ReactNode;
  className?: string;
  onChange: (next: boolean) => void;
  question: string;
  title: string;
  value: boolean;
}) => {
  return (
    <Stack className={cn("w-full flex-col items-start gap-2", className)}>
      <FormRowLabel label={title} />
      <YesNoToggle onChange={onChange} question={question} value={value}>
        {children}
      </YesNoToggle>
    </Stack>
  );
};
